export default "__VITE_ASSET__7024255e__"